<template>
  <div>
    <Header class="yh-header" active="/service/yxzt" />
    <div style="height: 70px"></div>
    <div class="container">
      <Feedback class="feedback" target-name="商品营销" :target-id="$route.params.id" black />
      <Favourite class="fav" target-name="service" :target-id="$route.params.id" />
      <CommodityMarketingTitle :bean="bean" />
      <CommodityMarketingMaterial :bean="planningMaterials" @download="onDownload" />
      <CommodityMarketingContent :bean="bean" />
      <CommodityMarketingDiscuss
        targetName="service"
        :bean="bean"
        @submit="onCreateDiscuss"
        @change="onDiscussChange"
        @like="onLike"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

import CommodityMarketingTitle from "@/components/CommodityMarketingTitle";
import CommodityMarketingMaterial from "@/components/CommodityMarketingMaterial";
import CommodityMarketingContent from "@/components/CommodityMarketingContent";
import CommodityMarketingDiscuss from "@/components/CommodityMarketingDiscuss";

import Favourite from "@/components/Favourite.vue";
import Feedback from "@/components/Feedback";

import { saveAs } from "file-saver";
import JSZip from "jszip";
import axios from "axios";

// axios.defaults.withCredentials = true;

function imageToCanvas(src, cb) {
  var canvas = document.createElement("CANVAS");
  var ctx = canvas.getContext("2d");
  var img = new Image();
  img.src = src;
  img.onload = function() {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    cb(canvas);
  };
}
function imageToBlob(src, cb) {
  imageToCanvas(src, function(canvas) {
    cb(dataURLToBlob(canvasToDataURL(canvas)));
  });
}
function canvasToDataURL(canvas, format, quality) {
  return canvas.toDataURL(format || "image/jpeg", quality || 1.0);
}
function dataURLToBlob(dataurl) {
  var arr = dataurl.split(",");
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export default {
  name: "ProductServiceDetail",
  components: {
    Header,
    CommodityMarketingTitle,
    CommodityMarketingMaterial,
    CommodityMarketingContent,
    CommodityMarketingDiscuss,

    Favourite,
    Feedback
  },
  computed: {
    bean() {
      let bean = this.$store.state.marketing.commodityMarketing.get;

      bean.planningMaterials = this.$store.state.marketing.commodityMarketingPlanningMaterial.retrieve.results;
      bean.images = this.$store.state.marketing.commodityMarketingImage.retrieve.results;

      return bean;
    },
    planningMaterials() {
      return this.$store.state.marketing.commodityMarketingPlanningMaterial
        .retrieve.results;
    },
    images() {
      return this.$store.state.marketing.commodityMarketingImage.retrieve
        .results;
    }
  },
  created() {
    this.$store.dispatch("commodityMarketing", {
      packageName: "marketing",
      className: "commodityMarketing",
      methodName: "get",
      params: {
        id: this.$route.params.id
      }
    });
    this.$store.dispatch("commodityMarketingImagePage", {
      packageName: "marketing",
      className: "commodityMarketingImage",
      methodName: "retrieve",
      params: {
        parentId: this.$route.params.id
      }
    });
    this.$store.dispatch("commodityMarketingPlanningMaterialPage", {
      packageName: "marketing",
      className: "commodityMarketingPlanningMaterial",
      methodName: "retrieve",
      params: {
        parentId: this.$route.params.id
      }
    });
    this.$store.dispatch("userCommentPage", {
      packageName: "user",
      className: "userComment",
      methodName: "getCommentsByTargetWithMe",
      params: {
        targetName: "service",
        targetId: this.$route.params.id,

        numPerPage: 3
      }
    });
    this.$store.dispatch("createHistory", {
      packageName: "user",
      className: "userHistory",
      methodName: "create",
      params: {
        targetName: "service",
        targetId: this.$route.params.id
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "商品营销-详情",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  methods: {
    async onCreateDiscuss(e) {
      await this.$store.dispatch("createComment", {
        packageName: "user",
        className: "userComment",
        methodName: "create",
        params: {
          ...e
        }
      });

      this.$message.success("评论成功！");

      this.$store.dispatch("userCommentPage", {
        packageName: "user",
        className: "userComment",
        methodName: "getCommentsByTargetWithMe",
        params: {
          targetName: "service",
          targetId: this.$route.params.id,

          numPerPage: 3
        }
      });
    },
    async onLike(e) {
      await this.$store.dispatch("createLike", {
        packageName: "user",
        className: "userLike",
        methodName: "create",
        params: {
          targetName: "comment",
          targetId: e.id
        }
      });

      this.$message.success("点赞成功！");
    },
    onDiscussChange(e) {
      this.$store.dispatch("userCommentPage", {
        packageName: "user",
        className: "userComment",
        methodName: "getCommentsByTargetWithMe",
        params: {
          targetName: "service",
          targetId: this.$route.params.id,

          pageNum: e,
          numPerPage: 3
        }
      });
    },

    // onDownload() {
    //   const zip = new JSZip();

    //   const filename = this.bean.name;

    //   zip.file("README.txt", "文件模块都分好了，自己看文件夹就行");

    //   const material = zip.folder("企划物料");

    //   this.bean.planningMaterials.forEach(element => {
    //     const dir = material.folder(element.name);
    //     const url = this.util.getImageUrl(element.image);

    //     const promise = $.get(
    //       `/api/marketing/commodityMarketing/download?url=${url}`
    //     );
    //     dir.file("image.jpg", promise);
    //   });

    //   zip.generateAsync({ type: "blob" }).then(function(content) {
    //     saveAs(content, filename);
    //   });
    // },

    // onDownload() {
    //   let url = "";
    //   if (process.env.NODE_ENV === "development") {
    //     url =
    //       "http://localhost:8080/api/marketing/commodityMarketing/download?urls=";
    //   } else {
    //     url =
    //       "http://fresh-wiki.yonghui.cn/api/marketing/commodityMarketing/download?urls=";
    //   }

    //   const urls = this.bean.planningMaterials.map(e => {
    //     return this.util.getImageUrl(e.image);
    //   });

    //   window.open(url + urls.join(","));
    // },

    onDownload() {
      let url = "";
      if (process.env.NODE_ENV === "development") {
        url =
          "http://localhost:8080/api/marketing/commodityMarketing/download?id=" +
          this.$route.params.id;
      } else {
        url =
          "http://fresh-wiki.yonghui.cn/api/marketing/commodityMarketing/download?id=" +
          this.$route.params.id;
      }

      window.open(url);
    }
  }
};
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1100px;
  top: 100px;
  left: calc((100vw - 1100px) / 2);
  position: absolute;

  // overflow: hidden;
}

.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.el-main {
  position: absolute;
  // padding-top: 0;
}
.fav {
  position: absolute;
  top: 50px;
  right: 40px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.2);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0);
}
.feedback {
  position: absolute;
  top: 50px;
  right: 140px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.2);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0);
}
</style>
